import Checkbox from '@amzn/awsui-components-react-v3/polaris/checkbox';
import ColumnLayout from '@amzn/awsui-components-react-v3/polaris/column-layout';
import Container from '@amzn/awsui-components-react-v3/polaris/container';
import Flashbar from '@amzn/awsui-components-react-v3/polaris/flashbar';
import FormField from '@amzn/awsui-components-react-v3/polaris/form-field';
import Header from '@amzn/awsui-components-react-v3/polaris/header';
import Modal from '@amzn/awsui-components-react-v3/polaris/modal';
import Select from 'react-select';
import React from 'react';

import { Button, Input } from 'AWS-UI-Components-React';

import { ERROR_MESSAGE } from '../../../constants/views';

export class CMAddMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        channelMappingsToAdd: [],
        cognosChannelType: '',
        cognosChannelDescription: '',
        cognosParentChannel: '',
        cognosChannel: '',
        derivedCognosChannel: '',
        derivedOptions: [],
        groupCode: '',
        hcpMerchantChannel: '',
        hcpChannelType: '',
        marketplaceId: '',
        derivedMarketplaceId: '',
        marketplaceName: '',
        excluded: false,
        hcpExcluded: false,
        ignored: false,
        comment: props.comment,
    };
  }

  onDismiss = () => {
    this.props.onDismiss();

    this.setState({
      channelMappingsToAdd: [], cognosChannelType: '', cognosChannelDescription: '', cognosParentChannel: '',
      cognosChannel: '', derivedCognosChannel: '', derivedOptions: [], groupCode: '', hcpMerchantChannel: '', hcpChannelType: '', marketplaceId: '', derivedMarketplaceId: '',
      marketplaceName: '', excluded: false, hcpExcluded: false, ignored: false, comment: this.props.comment,
    });
  };

  onUpdateComment = (event) => {
    this.setState({ comment: event.detail.value });
  };

  onExcludeChange = (event) => {
    this.setState({ excluded: event.detail.checked });
  };

  onHCPExcludeChange = (event) => {
    this.setState({ hcpExcluded: event.detail.checked });
  };

  onIgnoreChange = (event) => {
    this.setState({ ignored: event.detail.checked });
  };

  onCognosChannelTypeChange = (event) => {
    this.setState({ cognosChannelType: event.detail.value });
  };

  onCognosParentChannelChange = (selectedOption) => {
    this.setState({ cognosParentChannel: selectedOption.value });
  };

  onCognosChannelChange = (selectedOption) => {
    this.setState({ cognosChannel: selectedOption.value });
  };

  onDerivedCognosChannelChange = (selectedOption) => {
    this.setState({ derivedCognosChannel: selectedOption.value });
  };

  onCognosChannelDescriptionChange = (event) => {
    this.setState({ cognosChannelDescription: event.detail.value });
  };

  onGroupCodeChange = (selectedOption) => {
    this.setState({ groupCode: selectedOption.value });
  };

  onHCPMerchantChannelChange = (selectedOption) => {
    this.setState({ hcpMerchantChannel: selectedOption.value });
  };

  onHCPChannelTypeChange = (event) => {
    this.setState({ hcpChannelType: event.detail.value });
  };

  onMarketplaceIdChange = (selectedOption) => {
    let marketplaceName = this.props.marketplaceConfig.find(item => (item.derivedMarketplaceIds && item.derivedMarketplaceIds.find((id) => id === selectedOption.value))).detail;
    let derivedIds = this.props.marketplaceConfig.find(item => (item.derivedMarketplaceIds &&
      item.derivedMarketplaceIds.find((derivedId) => derivedId === parseInt(selectedOption.value)))).derivedMarketplaceIds;
    let derivedOptions = derivedIds && derivedIds.map((id) => {
      return {
        value: id,
        label: `${ id }`,
      };
    });
    this.setState({ marketplaceId: selectedOption.value, marketplaceName: marketplaceName, derivedOptions: derivedOptions, derivedMarketplaceId: '' });
  };

  onDerivedMarketplaceIdChange = (selectedOption) => {
    this.setState({ derivedMarketplaceId: selectedOption.value });
  };

  addChannelMapping = () => {
    let channelMappings = {};
    channelMappings.comments = this.state.comment == null ? this.props.comment : this.state.comment;
    channelMappings.username = this.props.username;
    channelMappings.excluded = this.state.excluded;
    channelMappings.hcpExcluded = this.state.hcpExcluded;
    channelMappings.ignored = this.state.ignored;
    channelMappings.cognosChannelType = this.state.cognosChannelType;
    channelMappings.cognosParentChannel = this.state.cognosParentChannel;
    channelMappings.cognosChannel = this.state.cognosChannel.toUpperCase();
    channelMappings.derivedCognosChannel = this.state.derivedCognosChannel;
    channelMappings.channelDescription = this.state.cognosChannelDescription;
    channelMappings.groupCode = this.state.groupCode;
    channelMappings.version = "0";
    channelMappings.hcpMerchantChannel = this.state.hcpMerchantChannel.toUpperCase();
    channelMappings.hcpChannelType = this.state.hcpChannelType;
    channelMappings.phoenixChannel = this.state.hcpMerchantChannel.toUpperCase();
    channelMappings.derivedMarketplaceId = parseInt(this.state.derivedMarketplaceId);
    channelMappings.marketplaceId = parseInt(this.state.marketplaceId);
    channelMappings.marketplaceName = this.state.marketplaceName;
    channelMappings.id = this.state.cognosChannelType + "#" + this.state.hcpChannelType + "#*";
    this.props.addChannelMappings(channelMappings);
  };

  getCognosParameters = () => {
    return (
      <Container
        header={
          <Header variant="h2">
            Cognos Parameters
          </Header>
        }
      >
        <ColumnLayout columns={3} borders="all">
          <FormField label="Cognos Channel Type" constraintText="Must be a number" >
            <Input
              onChange={this.onCognosChannelTypeChange}
              value={this.state.cognosChannelType}
            />
          </FormField>
          <FormField label="Cognos Parent Channel">
            <Select
              options={this.props.dropdownOptions.cognosParentChannelOptions}
              onChange={( selectedOption ) => this.onCognosParentChannelChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
          <FormField label="Cognos Channel">
            <Select
              options={this.props.dropdownOptions.cognosChannelOptions}
              onChange={( selectedOption ) =>  this.onCognosChannelChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
          <FormField label="Derived Cognos Channel">
            <Select
              options={this.props.dropdownOptions.hcpChannelOptions}
              onChange={( selectedOption ) => this.onDerivedCognosChannelChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
          <FormField label="Cognos Channel Description">
            <Input
              onChange={this.onCognosChannelDescriptionChange}
              value={this.state.cognosChannelDescription}
            />
          </FormField>
          <FormField label="Cognos Group Code">
            <Select
              options={this.props.dropdownOptions.groupCodeOptions}
              onChange={( selectedOption ) =>  this.onGroupCodeChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
        </ColumnLayout>
      </Container>
    )
  };

  getHCPParameters = () => {
      return (
        <Container
          header={
            <Header variant="h2">
              HCP Parameters
            </Header>
          }
        >
        <ColumnLayout columns={2} borders="all">
          <FormField label="HCP Merchant Channel">
            <Select
              options={this.props.dropdownOptions.hcpChannelOptions}
              onChange={( selectedOption ) => this.onHCPMerchantChannelChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
          <FormField label="HCP Channel Type" constraintText="Must be a number" >
            <Input onChange={this.onHCPChannelTypeChange}
                   value={this.state.hcpChannelType}
            />
          </FormField>
        </ColumnLayout>
        </Container>
      )
  };

  getMetadataParameters = () => {
    return(
      <Container
        header={
          <Header variant="h2" >
            Metadata Parameters
          </Header>
        }
      >
        <ColumnLayout columns={2} borders="all">
          <FormField label="Marketplace Id">
            <Select
              options={this.props.dropdownOptions.marketplaceIdOptions}
              onChange={( selectedOption ) => this.onMarketplaceIdChange(selectedOption)}
              isMulti={false}
              isDisabled={this.props.readOnly}
            />
          </FormField>
          <FormField label="Marketplace Name">
            <Input
              value={this.state.marketplaceName}
              disabled
            />
          </FormField>
        </ColumnLayout>
        <div className="awsui-util-mt-s">
        <FormField label="Derived Marketplace Id (Put F3 marketplace Id otherwise the Marketplace Id)">
          <Select
            options={this.state.derivedOptions}
            onChange={( selectedOption ) => this.onDerivedMarketplaceIdChange(selectedOption)}
            isMulti={false}
            isDisabled={this.props.readOnly}
          />
        </FormField>
        </div>

        <div className="awsui-util-mt-s">
        <Checkbox
          onChange={this.onExcludeChange}
          checked={this.state.excluded}
        >
          Cognos Excluded
        </Checkbox>
        <Checkbox
          onChange={this.onHCPExcludeChange}
          checked={this.state.hcpExcluded}
        >
          HCP Excluded
        </Checkbox>
        <Checkbox
          onChange={this.onIgnoreChange}
          checked={this.state.ignored}
        >
          Ignored
        </Checkbox>
        </div>
        <h3>Comments:</h3>
        <div>
          <Input value={this.props.comment} onChange={this.onUpdateComment}/>
        </div>
      </Container>
    )
  };

  getContent = () => {
    return (
      <div>
        { this.getCognosParameters() }
        { this.getHCPParameters() }
        { this.getMetadataParameters() }
      </div>
    )
  };

  isMappingComplete = () => {
    return this.state.cognosChannelType !== '' && this.state.cognosChannelDescription !== '' &&   this.state.cognosParentChannel !== '' &&
           this.state.cognosChannel !== '' && this.state.derivedCognosChannel !== '' && this.state.groupCode!== '' && this.state.hcpMerchantChannel !== ''
           && this.state.hcpChannelType !== '' && this.state.marketplaceId !== '' && this.state.derivedMarketplaceId !== '' &&
           this.state.marketplaceName !== '' && !isNaN(parseInt(this.state.cognosChannelType)) &&  !isNaN(parseInt(this.state.hcpChannelType));
  };

  render() {
    const {
      visible,
      expandToFit = true,
      size = 'large',
      errorScreenMessage,
      successScreenMessage
    } = this.props;

    return (
      <div>
        <Modal
          visible={visible}
          header={'Add Channel Mapping'}
          onDismiss={this.onDismiss}
          expandToFit={expandToFit}
          size={size}
          footer={
            <span className="awsui-util-f-r">
              <Button
                key={'ADD_CHANNEL_MAPPING_BUTTON'}
                variant={'primary'}
                onClick={this.addChannelMapping}
                disabled={!this.isMappingComplete()}
              >
                Add Channel Mapping
              </Button>
            </span>
          }
        >
          <div>
            <div>
              <Flashbar
                items={
                  errorScreenMessage
                    ? [
                        {
                          type: 'error',
                          content: `${ERROR_MESSAGE}${errorScreenMessage}`,
                          onDismiss: () => this.setState({ errorScreenMessage: null }),
                        },
                      ]
                    : []
                }
              />
            </div>
            <div>
              <Flashbar
                items={
                  successScreenMessage
                  ? [
                      {
                        type: 'success',
                        dismissible: true,
                        content: `${successScreenMessage}`,
                        onDismiss: () => this.setState({ successScreenMessage: null }),
                      },
                    ]
                  : []
                }
              />
            </div>
            {this.getContent()}
            <div style={{ textAlign: 'center', fontStyle: 'italic' }}>
              <p>Impact of published changes on data will be visible after the next data refresh.</p>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/cm_add_mapping.jsx